export default "__VITE_ASSET__c0517074__"